export default function ScrollToTop() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-40 w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all shadow-lg cursor-pointer"
      aria-label="返回顶部"
      title="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}